// Generated by scripts/build-spectral-tables.mjs — do not edit by hand.
// Grid: 360–830 nm in 5 nm steps (95 values).
//
// LICENCE: this file (and only this file) is licensed CC BY-SA 4.0
// (https://creativecommons.org/licenses/by-sa/4.0/), because it is derived from CIE datasets:
//   CIE (2019) Colour-matching functions of CIE 1931 standard colorimetric observer,
//   doi:10.25039/CIE.DS.xvudnb9b (CIE_xyz_1931_2deg.csv)
//   CIE (2019) CIE standard illuminant D65, doi:10.25039/CIE.DS.hjfjmt59 (CIE_std_illum_D65.csv)
// The values below are the official 1 nm values subsampled at 5 nm, unchanged.

/** CIE 1931 2° colour-matching function x̄(λ). */
export const CIE_X_5NM: readonly number[] = [
  0.0001299, 0.0002321, 0.0004149, 0.0007416, 0.001368, 0.002236, 0.004243, 0.00765, 0.01431,
  0.02319, 0.04351, 0.07763, 0.13438, 0.21477, 0.2839, 0.3285, 0.34828, 0.34806, 0.3362, 0.3187,
  0.2908, 0.2511, 0.19536, 0.1421, 0.09564, 0.05795001, 0.03201, 0.0147, 0.0049, 0.0024, 0.0093,
  0.0291, 0.06327, 0.1096, 0.1655, 0.2257499, 0.2904, 0.3597, 0.4334499, 0.5120501, 0.5945, 0.6784,
  0.7621, 0.8425, 0.9163, 0.9786, 1.0263, 1.0567, 1.0622, 1.0456, 1.0026, 0.9384, 0.8544499, 0.7514,
  0.6424, 0.5419, 0.4479, 0.3608, 0.2835, 0.2187, 0.1649, 0.1212, 0.0874, 0.0636, 0.04677, 0.0329,
  0.0227, 0.01584, 0.01135916, 0.008110916, 0.005790346, 0.004109457, 0.002899327, 0.00204919,
  0.001439971, 0.0009999493, 0.0006900786, 0.0004760213, 0.0003323011, 0.0002348261, 0.0001661505,
  0.000117413, 0.00008307527, 0.00005870652, 0.00004150994, 0.00002935326, 0.00002067383,
  0.00001455977, 0.00001025398, 0.000007221456, 0.000005085868, 0.000003581652, 0.000002522525,
  0.000001776509, 0.000001251141,
];

/** CIE 1931 2° colour-matching function ȳ(λ) (equals V(λ)). */
export const CIE_Y_5NM: readonly number[] = [
  0.000003917, 0.000006965, 0.00001239, 0.00002202, 0.000039, 0.000064, 0.00012, 0.000217, 0.000396,
  0.00064, 0.00121, 0.00218, 0.004, 0.0073, 0.0116, 0.01684, 0.023, 0.0298, 0.038, 0.048, 0.06,
  0.0739, 0.09098, 0.1126, 0.13902, 0.1693, 0.20802, 0.2586, 0.323, 0.4073, 0.503, 0.6082, 0.71,
  0.7932, 0.862, 0.9148501, 0.954, 0.9803, 0.9949501, 1, 0.995, 0.9786, 0.952, 0.9154, 0.87, 0.8163,
  0.757, 0.6949, 0.631, 0.5668, 0.503, 0.4412, 0.381, 0.321, 0.265, 0.217, 0.175, 0.1382, 0.107,
  0.0816, 0.061, 0.04458, 0.032, 0.0232, 0.017, 0.01192, 0.00821, 0.005723, 0.004102, 0.002929,
  0.002091, 0.001484, 0.001047, 0.00074, 0.00052, 0.0003611, 0.0002492, 0.0001719, 0.00012,
  0.0000848, 0.00006, 0.0000424, 0.00003, 0.0000212, 0.00001499, 0.0000106, 0.0000074657,
  0.0000052578, 0.0000037029, 0.0000026078, 0.0000018366, 0.0000012934, 9.1093e-7, 6.4153e-7,
  4.5181e-7,
];

/** CIE 1931 2° colour-matching function z̄(λ). */
export const CIE_Z_5NM: readonly number[] = [
  0.0006061, 0.001086, 0.001946, 0.003486, 0.006450001, 0.01054999, 0.02005001, 0.03621, 0.06785001,
  0.1102, 0.2074, 0.3713, 0.6456, 1.0390501, 1.3856, 1.62296, 1.74706, 1.7826, 1.77211, 1.7441,
  1.6692, 1.5281, 1.28764, 1.0419, 0.8129501, 0.6162, 0.46518, 0.3533, 0.272, 0.2123, 0.1582,
  0.1117, 0.07824999, 0.05725001, 0.04216, 0.02984, 0.0203, 0.0134, 0.008749999, 0.005749999,
  0.0039, 0.002749999, 0.0021, 0.0018, 0.001650001, 0.0014, 0.0011, 0.001, 0.0008, 0.0006, 0.00034,
  0.00024, 0.00019, 0.0001, 0.00004999999, 0.00003, 0.00002, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
];

/** CIE standard illuminant D65, relative spectral power (100 at 560 nm). */
export const CIE_D65_5NM: readonly number[] = [
  46.6383, 49.3637, 52.0891, 51.0323, 49.9755, 52.3118, 54.6482, 68.7015, 82.7549, 87.1204, 91.486,
  92.4589, 93.4318, 90.057, 86.6823, 95.7736, 104.865, 110.936, 117.008, 117.41, 117.812, 116.336,
  114.861, 115.392, 115.923, 112.367, 108.811, 109.082, 109.354, 108.578, 107.802, 106.296, 104.79,
  106.239, 107.689, 106.047, 104.405, 104.225, 104.046, 102.023, 100, 98.1671, 96.3342, 96.0611,
  95.788, 92.2368, 88.6856, 89.3459, 90.0062, 89.8026, 89.5991, 88.6489, 87.6987, 85.4936, 83.2886,
  83.4939, 83.6992, 81.863, 80.0268, 80.1207, 80.2146, 81.2462, 82.2778, 80.281, 78.2842, 74.0027,
  69.7213, 70.6652, 71.6091, 72.979, 74.349, 67.9765, 61.604, 65.7448, 69.8856, 72.4863, 75.087,
  69.3398, 63.5927, 55.0054, 46.4182, 56.6118, 66.8054, 65.0941, 63.3828, 63.8434, 64.304, 61.8779,
  59.4519, 55.7054, 51.959, 54.6998, 57.4406, 58.8765, 60.3125,
];
